module.exports = __webpack_public_path__ + "static/media/index-popup-big-bg.abf89c8e.png";